import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-media-play',
    templateUrl: './media-play.component.html',
    styleUrls: ['./media-play.component.scss'],
    standalone: false
})
export class MediaPlayComponent implements OnInit {
  @Input() underPlay: boolean = false;
  @Input() shouldShowPlay: boolean = true;
  @Input() duration: number = 0;
  @Input() currentTime: number = 0;
  @Output() played = new EventEmitter<{underPlay: boolean}>();

  constructor() { }

  ngOnInit() {
  }

  onPlay() {
    this.underPlay = true;
    this.played.emit({underPlay: this.underPlay});
  }

}
